var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGmb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7628 12.2759C23.7628 11.4602 23.6967 10.64 23.5556 9.83752H12.2368V14.4585H18.7185C18.4495 15.9489 17.5853 17.2673 16.3198 18.105V21.1034H20.1868C22.4576 19.0133 23.7628 15.9268 23.7628 12.2759Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2373 24.0002C15.4737 24.0002 18.2031 22.9375 20.1917 21.1032L16.3247 18.1049C15.2488 18.8368 13.8599 19.2513 12.2417 19.2513C9.11105 19.2513 6.45663 17.1392 5.50421 14.2996H1.51376V17.3906C3.55088 21.4427 7.70006 24.0002 12.2373 24.0002Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49974 14.3001C4.99707 12.8097 4.99707 11.1959 5.49974 9.70557V6.61462H1.5137C-0.188303 10.0054 -0.188303 14.0003 1.5137 17.391L5.49974 14.3001Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2373 4.74948C13.9481 4.72302 15.6016 5.36678 16.8406 6.54848L20.2667 3.12243C18.0973 1.08532 15.218 -0.0346491 12.2373 0.000625561C7.70009 0.000625561 3.55091 2.55804 1.51379 6.61462L5.49983 9.70557C6.44784 6.86155 9.10667 4.74948 12.2373 4.74948Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGmb);
export default __webpack_public_path__ + "static/media/logoGMB.a57b1c686f2a13f1592054f0b673afb0.svg";
export { ForwardRef as ReactComponent };